/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Remove_Language_AriaInputs */



/**
* | output |
* | --- |
* | "Remove language" |
*
* @param {Knp_Guide_Remove_Language_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_remove_language_aria = /** @type {((inputs?: Knp_Guide_Remove_Language_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Remove_Language_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la langue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprache entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi lingua")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar idioma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言語を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भाषा हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover idioma")
	return /** @type {LocalizedString} */ ("Remove language")
});